module.exports = __webpack_public_path__ + "static/img/28.232ce08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/28.png
// module id = 198
// module chunks = 1